import { emailClickData } from "@redotech/redo-model/email-builder/clickable-elements";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod/v4";

export const getEmailTemplateClickTrackingData = {
  name: "getEmailTemplateClickTrackingData" as const,
  input: z.object({ templateId: zExt.objectId() }),
  output: z.object({ results: z.array(emailClickData) }),
};
